import React, { useEffect, useState } from 'react'
import { Card, Row, Col } from 'antd'
import { Pie } from 'react-chartjs-2'
import { GlucoseText } from './styles'
import { Chart, ArcElement } from 'chart.js'

Chart.register(ArcElement);

function GlucoseTrendCard(props) {
  const [values, setValues] = useState(props.trends)

  useEffect(() => {
    setValues(props.trends)
  }, [props])

  return (
    <Card className="mt-2" title="แนวโน้มค่าน้ำตาล">
      <Row>
        <Col span={12}>
          <Row>
            <GlucoseText span={12} color="black">
              รายการ
            </GlucoseText>
            <GlucoseText span={12} color="black">
              จำนวนครั้ง
            </GlucoseText>
            <GlucoseText span={12} color="#32cd32">
              น้ำตาลปกติ
            </GlucoseText>
            <GlucoseText span={12} color="#32cd32">
              {values.mid}
            </GlucoseText>
            <GlucoseText span={12} color="red">
              น้ำตาลต่ำ
            </GlucoseText>
            <GlucoseText span={12} color="red">
              {values.low}
            </GlucoseText>
            <GlucoseText span={12} color="#76c9d4">
              น้ำตาลสูง
            </GlucoseText>
            <GlucoseText span={12} color="#76c9d4">
              {values.high}
            </GlucoseText>
            <GlucoseText span={12} color="black">
              ทั้งหมด
            </GlucoseText>
            <GlucoseText span={12} color="black">
              {values.low + values.mid + values.high}
            </GlucoseText>
          </Row>
        </Col>
        {values.low + values.mid + values.high ? (
          <Col span={12}>
            <Pie
              data={values.pie}
              options={{
                legend: {
                  display: true,
                  position: 'right',
                },
              }}
            />
          </Col>
        ) : null}
      </Row>
    </Card>
  )
}

export default GlucoseTrendCard
